import { API_ENDPOINTS, ApiResponse } from 'services/api';
import httpClient from 'services/httpClient';

export interface MasterCategory {
  category: string;
}

export const masterCategoryService = {
  getList: async (params?: { search?: string; pageNumber?: number; pageSize?: number }) => {
    const response = await httpClient.get<ApiResponse<MasterCategory>>(
      API_ENDPOINTS.MASTER_CATEGORY.LIST,
      {
        params: {
          pageNumber: params?.pageNumber || 1,
          pageSize: params?.pageSize || 100,
          search: params?.search || ''
        }
      }
    );
    return response.data;
  }
};
